import React from "react";

export default function UserProfileDetails(props) {
	if (!props.details) {
		return null;
	}

	const { Customer, Address } = props.details;

	return (
		<div className="portal-dashboard-card h-100">
			<div className="portal-dashboard-card-header">
				<h4>User Profile</h4>
			</div>
			<div className="portal-dashboard-card-body">
				<div className="portal-profile-row">Username: {Customer.CellphoneNumber}</div>
				<div className="portal-profile-row">Name: {`${Customer.FirstName} ${Customer.Surname}`}</div>
				<div className="portal-profile-row">Cell: {Customer.CellphoneNumber}</div>
				<div className="portal-profile-row">
					Service ID: {Address ? `ZNG${Address.ServiceId}` : ""}
				</div>
			</div>
		</div>
	);
}
